import { useEffect } from 'react';
import { autorun } from 'mobx';
import useInfraStores from '@app/hooks/useInfraStores';
import { setIdentity } from './analytics';
import type { Identity } from './types';

function toIdentity(organization: UserOrganization | undefined): Identity | null {
  if (!organization) return null;
  return {
    organization_id: organization.id || '',
    organization_name: organization.data?.name,
  };
}

export function useIdentitySync(): void {
  const { userStore } = useInfraStores();

  useEffect(() => {
    return autorun(() => {
      setIdentity(toIdentity(userStore.selectedOrganization));
    });
  }, [userStore]);
}
